import { Button, Divider, Space } from "antd";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import api from "utils/api";
import utils from "utils";
import NestedFormViewer from "../NestedFormViewer";
import { CheckCircleFilled, CloseCircleFilled } from "Common/ReactIcons";
import AIFormDrawer from "Pages/Patient/AIFormHistory/AIFormDrawer";
import { CloseCircleOutlined } from "Common/ReactIcons";
import { CheckCircleOutlined } from "Common/ReactIcons";
import { EditOutlined } from "@ant-design/icons";
import AIFormCombinedView from "./AIFormCombinedView";
import { sortData } from "./AIForm";
const AIFormAssistant = (props) => {
  const history = useHistory();
  const [aiFormData, steAIFormData] = useState([]);
  const [showAIFormDrawer, setShowAIFormDrawer] = useState(false);
  const [loading, setLoading] = useState(false);

  const {
    patient_name,
    patient_id,
    patient_last_name,
    patient_age,
    patient_gender,
    appointment_id,
    appointment_date_time,
    appointmentDetail,
    user_type,
    is_editable,
  } = props.location.state || {};

  const getAllReviewedForms = async () => {
    setLoading(true);
    const payloadData = { appointment_id };

    try {
      const response = await api.get_reviewed_forms(payloadData);
      if (Array.isArray(response.data.data)) {
        const reviewedItems=sortData(response.data.data);
        for (const resultItem of reviewedItems) {
          if (Array.isArray(resultItem.value)) {
            resultItem.displayValue = resultItem.value.join(", ");
          } else if (typeof resultItem.value !== "object") {
            resultItem.displayValue = resultItem.value;
          }
          resultItem.isSaved = true;
        }
        steAIFormData(reviewedItems);
      } else {
        steAIFormData([]);
      }
    } catch (error) {
      console.error("Error fetching reviewed forms:", error);
      steAIFormData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (appointment_id) {
      getAllReviewedForms();
    }
  }, [appointment_id]);

  const handleAddNewClick = () => {
    setShowAIFormDrawer(true);
  };

  const handleCloseDrawer = () => {
    setShowAIFormDrawer(false);
    getAllReviewedForms();
  };



  return (
    <div>
      <Button className="previous-page-button" onClick={() => history.goBack()}>
        {`< Back To Previous Page`}
      </Button>

      <div className="reviewData-container">
        <div>
          <div className="patient-detail">
            {`${patient_name} ${patient_last_name}, ${patient_age} years, ${patient_gender}`}
          </div>
          <div className="appt-detail">
            {utils.FormatDate(appointment_date_time, "DATE_14")}&nbsp;
            {utils.FormatDate(appointment_date_time, "TIME_1")}
          </div>
        </div>
        <div>
          <Button className="addNewButton" onClick={handleAddNewClick}>
            Add New
          </Button>
          {showAIFormDrawer && (
            <AIFormDrawer
              patient_name={patient_name}
              patient_id={patient_id}
              patient_last_name={patient_last_name}
              patient_age={patient_age}
              patient_gender={patient_gender}
              visible={showAIFormDrawer}
              toggleDrawer={handleCloseDrawer}
              appointment_id={appointment_id}
              appointment_date_time={appointment_date_time}
              appointmentDetail={appointmentDetail}
              user_type={user_type}
              is_editable={is_editable}
            />
          )}
        </div>
      </div>

      <Divider />

      <div className="reviewscreen-component-parent-div">
      <AIFormCombinedView loading={loading} aiFormData={aiFormData} steAIFormData={steAIFormData} is_editable={is_editable} isSpeaking={false} chime_enabled={false} setLoading={setLoading} getAllReviewedForms={getAllReviewedForms} patient_id={patient_id} is_review_screen={true}/>
      </div>
    </div>
  );
};

export default AIFormAssistant;